import {useDataGrid} from "../components/data-grid/DataGridContext";
import ApiService from "../services/ApiService";
import {useEffect} from "react";
import DataGrid from "../components/data-grid/DataGrid";

export default function CompareHistory() {
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();

    const initGridData = async () => {
        const response = await ApiService.UserProject.CompareHistory(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'operationKey',
            enableRowSelection: false,
            columns: [
                {title: 'Date', dataIndex: 'createdDate', key: 'createdDate', sorter: false, render: (text, record) => `${new Date(text).toLocaleString()}`},
                {title: 'Base Project', dataIndex: 'baseProjectTitle', key: 'baseProjectTitle', sorter: false},
                {title: 'Base Plan', dataIndex: 'basePlanTitle', key: 'basePlanTitle', sorter: false},
                // {title: 'Flow Title', dataIndex: 'baseFlowTitle', key: 'baseFlowTitle', sorter: false},
                // {title: 'Geometry Title', dataIndex: 'baseGeoTitle', key: 'baseGeoTitle', sorter: false},
                {title: 'Comparison Project Title', dataIndex: 'compareProjectTitle', key: 'compareProjectTitle', sorter: false},
                {title: 'Comparison Plan', dataIndex: 'comparePlanTitle', key: 'comparePlanTitle', sorter: false},
                // {title: 'Flow Title', dataIndex: 'compareFlowTitle', key: 'compareFlowTitle', sorter: false},
                // {title: 'Geometry Title', dataIndex: 'compareGeoTitle', key: 'compareGeoTitle', sorter: false},
                {title: 'Message Count', dataIndex: 'messageCount', key: 'messageCount', sorter: false},
            ]
        })
    }, [])

    return (
        <>
            <DataGrid />
        </>
    )
}